import { JetView } from 'webix-jet';
import {
    devConfig, // Development configuration settings
    countries, // List of countries
    providersCasino, // Casino providers
    gamesCasino, // Casino games
    profile, // User profile information
} from 'config/config';

/**
 * Class representing the filter view for partner products.
 * @extends JetView
 */
export default class FilterPartnersProductsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size
        const id_partner = this.getParam('partner', true); // Partner ID from parameters

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for Partner ID
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                            labelPosition: 'top',
                            placeholder: _('Id'),
                            invalidMessage: _('Id is required'),
                        },
                        {
                            view: 'combo', // Dropdown for selecting provider
                            name: 'ProviderId',
                            localId: 'provider:combo',
                            label: _('Proveedor'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data fetching for providers
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data); // Parse and display provider data
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'richselect', // Dropdown for activation status
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                    ],
                },
            ],
        };

        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for verification status
                            name: 'IsVerified',
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for country filter
                            name: 'FilterCountry',
                            label: "<span class='icon-language'></span>" + _('Filtro País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'text', // Input for maximum value
                            name: 'Maximum',
                            type: 'number',
                            label: _('Máximo'),
                            labelPosition: 'top',
                            placeholder: _('Máximo'),
                            invalidMessage: _('Máximo is required'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for minimum value
                            name: 'Minimum',
                            type: 'number',
                            label: _('Mínimo'),
                            labelPosition: 'top',
                            placeholder: _('Mínimo'),
                            invalidMessage: _('Mínimo is required'),
                        },
                        {
                            view: 'text', // Input for processing time
                            name: 'ProcessingTime',
                            type: 'number',
                            label: "<span class='icon-history'></span>" + _('Tiempo Procesamiento'),
                            labelPosition: 'top',
                            placeholder: _('Tiempo Procesamiento'),
                            invalidMessage: _('Tiempo Procesamiento is required'),
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section with filters
                },
            ],
        };

        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 320 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Second left section with additional filters
                },
            ],
        };

        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for advanced filters
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Content of advanced filters
                            },
                        },
                    ],
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Button to add provider partner
                            value: _('Añadir Proveedor Partner'),
                            type: 'form',
                            hidden: !devConfig.getPermAction('partnersProvidersAdd', 'Add'), // Permission check
                            css: 'prm-partnersProvidersAdd',
                            width: screen == 'small' ? 0 : 200,
                            minWidth: 200,
                            click: () => {
                                this.app.callEvent('addProviderPartner:button', [[]]); // Event to add provider
                            },
                        },
                        {
                            view: 'button', // Button to clear filters
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            view: 'button', // Button to consult filters
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                filterdata.Partner = id_partner; // Add partner ID to filter data
                                this.app.callEvent('partnerProvider:filter', [filterdata]); // Trigger filter event
                                $$('b1').collapse(); // Collapse filter section
                                $$('a5').scrollTo(100, 0); // Scroll to specific position
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for main filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for main filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Upper section with filters
                                    accordion_section, // Accordion section for advanced filters
                                    buttons, // Button section
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [accordion_section1], // Main content
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element for small screens
                $$('grav2').hide(); // Hide another element for small screens
            }
        });
    }
}

// FILE DOCUMENTED
